
import { computed, defineComponent, reactive } from 'vue';
import { IVendaItem } from '@/models/Entidades/Vendas/IVenda';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import { useModalBase } from '@/core/composables/ModalBase';

export default defineComponent({
  name: 'FrenteCaixaDescontoModal',
  props: {
    visivel: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object as () => IVendaItem,
      required: true,
    },
  },
  components: {
    CampoNumerico,
  },
  emits: ['update:visivel', 'update:item', 'confirmar'],
  setup(props, { emit }) {
    const {
      modalBase,
    } = useModalBase(props, emit);
    const state = reactive({
      valorDesconto: 0,
    });

    const computedItem = computed({
      get: () => props.item,
      set: (val: IVendaItem) => {
        emit('update:item', val);
      },
    });

    function concluirDesconto() {
      emit('confirmar');
      modalBase.computedVisivel = false;
    }

    return {
      props,
      state,
      computedItem,
      modalBase,
      concluirDesconto,
    };
  },
});
